// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"14":"tv","326":"website","378":"user","535":"login","894":"services"}[chunkId] + "." + {"14":"b89ff1c7","326":"2209b38a","378":"29f078dd","535":"5ea094de","894":"1cb60f0e"}[chunkId] + ".chunk.css";
};